import { base_api, fetch_header } from "../configs/initvar"

const getBanners = async(params) => {
    const url = `${base_api}/banners${params ?? ''}`
    return await fetch (url,{ method: "GET", headers: fetch_header})
}
const getCategories = async(params) => {
  const url = `${base_api}/category${params ?? ''}`
  return await fetch (url,{ method: "GET", headers: fetch_header})
}
const getYears = async(params) => {
  const url = `${base_api}/years${params ?? ''}`
  return await fetch (url,{ method: "GET", headers: fetch_header})
}
const getContent = async(id) => {
  const url = `${base_api}/content/${id}`
  return await fetch (url,{ method: "GET", headers: fetch_header})
}
const getZoos = async(id) => {
  const url = `${base_api}/zoos`
  return await fetch (url,{ method: "GET", headers: fetch_header})
}
export {
  getBanners,
  getCategories,
  getYears,
  getContent,
  getZoos
}